import script from "./CtaSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaSection.vue?vue&type=script&setup=true&lang=js"

import "./CtaSection.vue?vue&type=style&index=0&id=6f30a14c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f30a14c"]])

export default __exports__